import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
import {
  Crime_Links_Common_FieldFragmentDoc,
  StatusFragmentDoc,
  FieldResponseResultFragmentDoc,
  FilterFragmentDoc
} from '@crimeos-frontend/crime-os/graphql-docs'
import * as Apollo from '@apollo/client'
export type SearchDropdownOptionFragment = {
  __typename: 'SearchDropdownOption'
  name: string
  optionType: Types.SearchOptionType
  iconUrl: string
  fields: Array<
    | { __typename: 'CheckboxGroupField' }
    | { __typename: 'DateField' }
    | { __typename: 'DateTimeField' }
    | {
        __typename: 'DropdownField'
        fieldId: string
        constFieldId: string
        name: string
        fieldType?: Types.FieldType | null
        placeholderText?: string | null
        options: Array<string>
      }
    | {
        __typename: 'EmailField'
        fieldId: string
        constFieldId: string
        name: string
        fieldType?: Types.FieldType | null
        placeholderText?: string | null
        validationRegex?: string | null
      }
    | {
        __typename: 'FieldsSelectorField'
        fieldId: string
        constFieldId: string
        name: string
        fieldType?: Types.FieldType | null
        placeholderText?: string | null
        options: Array<string>
      }
    | { __typename: 'FileUploaderField' }
    | {
        __typename: 'FloatField'
        fieldId: string
        constFieldId: string
        name: string
        fieldType?: Types.FieldType | null
        placeholderText?: string | null
      }
    | {
        __typename: 'IntegerField'
        fieldId: string
        constFieldId: string
        name: string
        fieldType?: Types.FieldType | null
        placeholderText?: string | null
      }
    | {
        __typename: 'LongTextField'
        fieldId: string
        constFieldId: string
        name: string
        fieldType?: Types.FieldType | null
        placeholderText?: string | null
      }
    | { __typename: 'LookupField' }
    | { __typename: 'MultiSelectField' }
    | {
        __typename: 'PhoneNumberField'
        fieldId: string
        constFieldId: string
        name: string
        fieldType?: Types.FieldType | null
        placeholderText?: string | null
      }
    | {
        __typename: 'PlainTextField'
        fieldId: string
        constFieldId: string
        name: string
        fieldType?: Types.FieldType | null
        placeholderText?: string | null
        validationRegex?: string | null
      }
    | { __typename: 'RadioGroupField' }
    | { __typename: 'TimeField' }
    | {
        __typename: 'URLField'
        fieldId: string
        constFieldId: string
        name: string
        fieldType?: Types.FieldType | null
        placeholderText?: string | null
        validationRegex?: string | null
      }
  >
}

export type BoardSpecialConfig_ApprovalRequestsSpecialConfig_Fragment = {
  __typename: 'ApprovalRequestsSpecialConfig'
  filtersConfig: Array<{
    __typename: 'Filter'
    filterId: string
    name: string
    isMultiSelectOption: boolean
    filterOptions: Array<{
      __typename: 'FilterOption'
      name: string
      id: string
    }>
  }>
}

export type BoardSpecialConfig_CrimeLinksSpecialConfig_Fragment = {
  __typename: 'CrimeLinksSpecialConfig'
  dropdownOptions: Array<{
    __typename: 'SearchDropdownOption'
    name: string
    optionType: Types.SearchOptionType
    iconUrl: string
    fields: Array<
      | { __typename: 'CheckboxGroupField' }
      | { __typename: 'DateField' }
      | { __typename: 'DateTimeField' }
      | {
          __typename: 'DropdownField'
          fieldId: string
          constFieldId: string
          name: string
          fieldType?: Types.FieldType | null
          placeholderText?: string | null
          options: Array<string>
        }
      | {
          __typename: 'EmailField'
          fieldId: string
          constFieldId: string
          name: string
          fieldType?: Types.FieldType | null
          placeholderText?: string | null
          validationRegex?: string | null
        }
      | {
          __typename: 'FieldsSelectorField'
          fieldId: string
          constFieldId: string
          name: string
          fieldType?: Types.FieldType | null
          placeholderText?: string | null
          options: Array<string>
        }
      | { __typename: 'FileUploaderField' }
      | {
          __typename: 'FloatField'
          fieldId: string
          constFieldId: string
          name: string
          fieldType?: Types.FieldType | null
          placeholderText?: string | null
        }
      | {
          __typename: 'IntegerField'
          fieldId: string
          constFieldId: string
          name: string
          fieldType?: Types.FieldType | null
          placeholderText?: string | null
        }
      | {
          __typename: 'LongTextField'
          fieldId: string
          constFieldId: string
          name: string
          fieldType?: Types.FieldType | null
          placeholderText?: string | null
        }
      | { __typename: 'LookupField' }
      | { __typename: 'MultiSelectField' }
      | {
          __typename: 'PhoneNumberField'
          fieldId: string
          constFieldId: string
          name: string
          fieldType?: Types.FieldType | null
          placeholderText?: string | null
        }
      | {
          __typename: 'PlainTextField'
          fieldId: string
          constFieldId: string
          name: string
          fieldType?: Types.FieldType | null
          placeholderText?: string | null
          validationRegex?: string | null
        }
      | { __typename: 'RadioGroupField' }
      | { __typename: 'TimeField' }
      | {
          __typename: 'URLField'
          fieldId: string
          constFieldId: string
          name: string
          fieldType?: Types.FieldType | null
          placeholderText?: string | null
          validationRegex?: string | null
        }
    >
  }>
}

export type BoardSpecialConfig_DashboardSpecialConfig_Fragment = {
  __typename: 'DashboardSpecialConfig'
  complaintsFilterConfig: Array<{
    __typename: 'Filter'
    filterId: string
    name: string
    isMultiSelectOption: boolean
    filterOptions: Array<{
      __typename: 'FilterOption'
      name: string
      id: string
    }>
  }>
  complaintsTableConfig: Array<{ __typename: 'ColumnConfig'; fieldId: string }>
}

export type BoardSpecialConfig_DataControllerRequestsSpecialConfig_Fragment = {
  __typename: 'DataControllerRequestsSpecialConfig'
  dataControllerStatuses: Array<{
    __typename: 'Status'
    statusId: string
    name: string
    color?: Types.ColorEnum | null
    order: number
  }>
  filtersConfig: Array<{
    __typename: 'Filter'
    filterId: string
    name: string
    isMultiSelectOption: boolean
    filterOptions: Array<{
      __typename: 'FilterOption'
      name: string
      id: string
    }>
  }>
}

export type BoardSpecialConfig_OsIntSpecialConfig_Fragment = {
  __typename: 'OsIntSpecialConfig'
  osIntHandleOptions: Array<{
    __typename: 'OsIntHandleOption'
    name: string
    optionType: Types.OsIntSearchInputType
    placeHolder: string
    regexPattern: string
    iconUrl?: string | null
  }>
  osIntStatuses: Array<{
    __typename: 'Status'
    statusId: string
    name: string
    color?: Types.ColorEnum | null
    order: number
  }>
}

export type BoardSpecialConfig_PendingActionsSpecialConfig_Fragment = {
  __typename: 'PendingActionsSpecialConfig'
  sendServiceRequestsTo: Types.SendServiceRequestsTo
}

export type BoardSpecialConfigFragment =
  | BoardSpecialConfig_ApprovalRequestsSpecialConfig_Fragment
  | BoardSpecialConfig_CrimeLinksSpecialConfig_Fragment
  | BoardSpecialConfig_DashboardSpecialConfig_Fragment
  | BoardSpecialConfig_DataControllerRequestsSpecialConfig_Fragment
  | BoardSpecialConfig_OsIntSpecialConfig_Fragment
  | BoardSpecialConfig_PendingActionsSpecialConfig_Fragment

export type BoardConfigFragment = {
  __typename: 'BoardConfig'
  externalLink?: string | null
  specialConfig?:
    | {
        __typename: 'ApprovalRequestsSpecialConfig'
        filtersConfig: Array<{
          __typename: 'Filter'
          filterId: string
          name: string
          isMultiSelectOption: boolean
          filterOptions: Array<{
            __typename: 'FilterOption'
            name: string
            id: string
          }>
        }>
      }
    | {
        __typename: 'CrimeLinksSpecialConfig'
        dropdownOptions: Array<{
          __typename: 'SearchDropdownOption'
          name: string
          optionType: Types.SearchOptionType
          iconUrl: string
          fields: Array<
            | { __typename: 'CheckboxGroupField' }
            | { __typename: 'DateField' }
            | { __typename: 'DateTimeField' }
            | {
                __typename: 'DropdownField'
                fieldId: string
                constFieldId: string
                name: string
                fieldType?: Types.FieldType | null
                placeholderText?: string | null
                options: Array<string>
              }
            | {
                __typename: 'EmailField'
                fieldId: string
                constFieldId: string
                name: string
                fieldType?: Types.FieldType | null
                placeholderText?: string | null
                validationRegex?: string | null
              }
            | {
                __typename: 'FieldsSelectorField'
                fieldId: string
                constFieldId: string
                name: string
                fieldType?: Types.FieldType | null
                placeholderText?: string | null
                options: Array<string>
              }
            | { __typename: 'FileUploaderField' }
            | {
                __typename: 'FloatField'
                fieldId: string
                constFieldId: string
                name: string
                fieldType?: Types.FieldType | null
                placeholderText?: string | null
              }
            | {
                __typename: 'IntegerField'
                fieldId: string
                constFieldId: string
                name: string
                fieldType?: Types.FieldType | null
                placeholderText?: string | null
              }
            | {
                __typename: 'LongTextField'
                fieldId: string
                constFieldId: string
                name: string
                fieldType?: Types.FieldType | null
                placeholderText?: string | null
              }
            | { __typename: 'LookupField' }
            | { __typename: 'MultiSelectField' }
            | {
                __typename: 'PhoneNumberField'
                fieldId: string
                constFieldId: string
                name: string
                fieldType?: Types.FieldType | null
                placeholderText?: string | null
              }
            | {
                __typename: 'PlainTextField'
                fieldId: string
                constFieldId: string
                name: string
                fieldType?: Types.FieldType | null
                placeholderText?: string | null
                validationRegex?: string | null
              }
            | { __typename: 'RadioGroupField' }
            | { __typename: 'TimeField' }
            | {
                __typename: 'URLField'
                fieldId: string
                constFieldId: string
                name: string
                fieldType?: Types.FieldType | null
                placeholderText?: string | null
                validationRegex?: string | null
              }
          >
        }>
      }
    | {
        __typename: 'DashboardSpecialConfig'
        complaintsFilterConfig: Array<{
          __typename: 'Filter'
          filterId: string
          name: string
          isMultiSelectOption: boolean
          filterOptions: Array<{
            __typename: 'FilterOption'
            name: string
            id: string
          }>
        }>
        complaintsTableConfig: Array<{
          __typename: 'ColumnConfig'
          fieldId: string
        }>
      }
    | {
        __typename: 'DataControllerRequestsSpecialConfig'
        dataControllerStatuses: Array<{
          __typename: 'Status'
          statusId: string
          name: string
          color?: Types.ColorEnum | null
          order: number
        }>
        filtersConfig: Array<{
          __typename: 'Filter'
          filterId: string
          name: string
          isMultiSelectOption: boolean
          filterOptions: Array<{
            __typename: 'FilterOption'
            name: string
            id: string
          }>
        }>
      }
    | {
        __typename: 'OsIntSpecialConfig'
        osIntHandleOptions: Array<{
          __typename: 'OsIntHandleOption'
          name: string
          optionType: Types.OsIntSearchInputType
          placeHolder: string
          regexPattern: string
          iconUrl?: string | null
        }>
        osIntStatuses: Array<{
          __typename: 'Status'
          statusId: string
          name: string
          color?: Types.ColorEnum | null
          order: number
        }>
      }
    | {
        __typename: 'PendingActionsSpecialConfig'
        sendServiceRequestsTo: Types.SendServiceRequestsTo
      }
    | null
}

export type BoardFragment = {
  __typename: 'Board'
  boardId: number
  name: string
  boardType: Types.BoardType
  displayState: Types.BoardDisplayState
  defaultIcon: string
  selectedIcon: string
  config: {
    __typename: 'BoardConfig'
    externalLink?: string | null
    specialConfig?:
      | {
          __typename: 'ApprovalRequestsSpecialConfig'
          filtersConfig: Array<{
            __typename: 'Filter'
            filterId: string
            name: string
            isMultiSelectOption: boolean
            filterOptions: Array<{
              __typename: 'FilterOption'
              name: string
              id: string
            }>
          }>
        }
      | {
          __typename: 'CrimeLinksSpecialConfig'
          dropdownOptions: Array<{
            __typename: 'SearchDropdownOption'
            name: string
            optionType: Types.SearchOptionType
            iconUrl: string
            fields: Array<
              | { __typename: 'CheckboxGroupField' }
              | { __typename: 'DateField' }
              | { __typename: 'DateTimeField' }
              | {
                  __typename: 'DropdownField'
                  fieldId: string
                  constFieldId: string
                  name: string
                  fieldType?: Types.FieldType | null
                  placeholderText?: string | null
                  options: Array<string>
                }
              | {
                  __typename: 'EmailField'
                  fieldId: string
                  constFieldId: string
                  name: string
                  fieldType?: Types.FieldType | null
                  placeholderText?: string | null
                  validationRegex?: string | null
                }
              | {
                  __typename: 'FieldsSelectorField'
                  fieldId: string
                  constFieldId: string
                  name: string
                  fieldType?: Types.FieldType | null
                  placeholderText?: string | null
                  options: Array<string>
                }
              | { __typename: 'FileUploaderField' }
              | {
                  __typename: 'FloatField'
                  fieldId: string
                  constFieldId: string
                  name: string
                  fieldType?: Types.FieldType | null
                  placeholderText?: string | null
                }
              | {
                  __typename: 'IntegerField'
                  fieldId: string
                  constFieldId: string
                  name: string
                  fieldType?: Types.FieldType | null
                  placeholderText?: string | null
                }
              | {
                  __typename: 'LongTextField'
                  fieldId: string
                  constFieldId: string
                  name: string
                  fieldType?: Types.FieldType | null
                  placeholderText?: string | null
                }
              | { __typename: 'LookupField' }
              | { __typename: 'MultiSelectField' }
              | {
                  __typename: 'PhoneNumberField'
                  fieldId: string
                  constFieldId: string
                  name: string
                  fieldType?: Types.FieldType | null
                  placeholderText?: string | null
                }
              | {
                  __typename: 'PlainTextField'
                  fieldId: string
                  constFieldId: string
                  name: string
                  fieldType?: Types.FieldType | null
                  placeholderText?: string | null
                  validationRegex?: string | null
                }
              | { __typename: 'RadioGroupField' }
              | { __typename: 'TimeField' }
              | {
                  __typename: 'URLField'
                  fieldId: string
                  constFieldId: string
                  name: string
                  fieldType?: Types.FieldType | null
                  placeholderText?: string | null
                  validationRegex?: string | null
                }
            >
          }>
        }
      | {
          __typename: 'DashboardSpecialConfig'
          complaintsFilterConfig: Array<{
            __typename: 'Filter'
            filterId: string
            name: string
            isMultiSelectOption: boolean
            filterOptions: Array<{
              __typename: 'FilterOption'
              name: string
              id: string
            }>
          }>
          complaintsTableConfig: Array<{
            __typename: 'ColumnConfig'
            fieldId: string
          }>
        }
      | {
          __typename: 'DataControllerRequestsSpecialConfig'
          dataControllerStatuses: Array<{
            __typename: 'Status'
            statusId: string
            name: string
            color?: Types.ColorEnum | null
            order: number
          }>
          filtersConfig: Array<{
            __typename: 'Filter'
            filterId: string
            name: string
            isMultiSelectOption: boolean
            filterOptions: Array<{
              __typename: 'FilterOption'
              name: string
              id: string
            }>
          }>
        }
      | {
          __typename: 'OsIntSpecialConfig'
          osIntHandleOptions: Array<{
            __typename: 'OsIntHandleOption'
            name: string
            optionType: Types.OsIntSearchInputType
            placeHolder: string
            regexPattern: string
            iconUrl?: string | null
          }>
          osIntStatuses: Array<{
            __typename: 'Status'
            statusId: string
            name: string
            color?: Types.ColorEnum | null
            order: number
          }>
        }
      | {
          __typename: 'PendingActionsSpecialConfig'
          sendServiceRequestsTo: Types.SendServiceRequestsTo
        }
      | null
  }
}

export type GetBoardsQueryVariables = Types.Exact<{ [key: string]: never }>

export type GetBoardsQuery = {
  __typename: 'Query'
  getBoards: {
    __typename: 'GetBoardsResult'
    boards: Array<{
      __typename: 'Board'
      boardId: number
      name: string
      boardType: Types.BoardType
      displayState: Types.BoardDisplayState
      defaultIcon: string
      selectedIcon: string
      config: {
        __typename: 'BoardConfig'
        externalLink?: string | null
        specialConfig?:
          | {
              __typename: 'ApprovalRequestsSpecialConfig'
              filtersConfig: Array<{
                __typename: 'Filter'
                filterId: string
                name: string
                isMultiSelectOption: boolean
                filterOptions: Array<{
                  __typename: 'FilterOption'
                  name: string
                  id: string
                }>
              }>
            }
          | {
              __typename: 'CrimeLinksSpecialConfig'
              dropdownOptions: Array<{
                __typename: 'SearchDropdownOption'
                name: string
                optionType: Types.SearchOptionType
                iconUrl: string
                fields: Array<
                  | { __typename: 'CheckboxGroupField' }
                  | { __typename: 'DateField' }
                  | { __typename: 'DateTimeField' }
                  | {
                      __typename: 'DropdownField'
                      fieldId: string
                      constFieldId: string
                      name: string
                      fieldType?: Types.FieldType | null
                      placeholderText?: string | null
                      options: Array<string>
                    }
                  | {
                      __typename: 'EmailField'
                      fieldId: string
                      constFieldId: string
                      name: string
                      fieldType?: Types.FieldType | null
                      placeholderText?: string | null
                      validationRegex?: string | null
                    }
                  | {
                      __typename: 'FieldsSelectorField'
                      fieldId: string
                      constFieldId: string
                      name: string
                      fieldType?: Types.FieldType | null
                      placeholderText?: string | null
                      options: Array<string>
                    }
                  | { __typename: 'FileUploaderField' }
                  | {
                      __typename: 'FloatField'
                      fieldId: string
                      constFieldId: string
                      name: string
                      fieldType?: Types.FieldType | null
                      placeholderText?: string | null
                    }
                  | {
                      __typename: 'IntegerField'
                      fieldId: string
                      constFieldId: string
                      name: string
                      fieldType?: Types.FieldType | null
                      placeholderText?: string | null
                    }
                  | {
                      __typename: 'LongTextField'
                      fieldId: string
                      constFieldId: string
                      name: string
                      fieldType?: Types.FieldType | null
                      placeholderText?: string | null
                    }
                  | { __typename: 'LookupField' }
                  | { __typename: 'MultiSelectField' }
                  | {
                      __typename: 'PhoneNumberField'
                      fieldId: string
                      constFieldId: string
                      name: string
                      fieldType?: Types.FieldType | null
                      placeholderText?: string | null
                    }
                  | {
                      __typename: 'PlainTextField'
                      fieldId: string
                      constFieldId: string
                      name: string
                      fieldType?: Types.FieldType | null
                      placeholderText?: string | null
                      validationRegex?: string | null
                    }
                  | { __typename: 'RadioGroupField' }
                  | { __typename: 'TimeField' }
                  | {
                      __typename: 'URLField'
                      fieldId: string
                      constFieldId: string
                      name: string
                      fieldType?: Types.FieldType | null
                      placeholderText?: string | null
                      validationRegex?: string | null
                    }
                >
              }>
            }
          | {
              __typename: 'DashboardSpecialConfig'
              complaintsFilterConfig: Array<{
                __typename: 'Filter'
                filterId: string
                name: string
                isMultiSelectOption: boolean
                filterOptions: Array<{
                  __typename: 'FilterOption'
                  name: string
                  id: string
                }>
              }>
              complaintsTableConfig: Array<{
                __typename: 'ColumnConfig'
                fieldId: string
              }>
            }
          | {
              __typename: 'DataControllerRequestsSpecialConfig'
              dataControllerStatuses: Array<{
                __typename: 'Status'
                statusId: string
                name: string
                color?: Types.ColorEnum | null
                order: number
              }>
              filtersConfig: Array<{
                __typename: 'Filter'
                filterId: string
                name: string
                isMultiSelectOption: boolean
                filterOptions: Array<{
                  __typename: 'FilterOption'
                  name: string
                  id: string
                }>
              }>
            }
          | {
              __typename: 'OsIntSpecialConfig'
              osIntHandleOptions: Array<{
                __typename: 'OsIntHandleOption'
                name: string
                optionType: Types.OsIntSearchInputType
                placeHolder: string
                regexPattern: string
                iconUrl?: string | null
              }>
              osIntStatuses: Array<{
                __typename: 'Status'
                statusId: string
                name: string
                color?: Types.ColorEnum | null
                order: number
              }>
            }
          | {
              __typename: 'PendingActionsSpecialConfig'
              sendServiceRequestsTo: Types.SendServiceRequestsTo
            }
          | null
      }
    }>
  }
}

export const SearchDropdownOptionFragmentDoc = gql`
  fragment SearchDropdownOption on SearchDropdownOption {
    name
    optionType
    iconUrl
    fields {
      ...Crime_Links_Common_Field
    }
  }
  ${Crime_Links_Common_FieldFragmentDoc}
`
export const BoardSpecialConfigFragmentDoc = gql`
  fragment BoardSpecialConfig on BoardSpecialConfig {
    ... on OsIntSpecialConfig {
      osIntHandleOptions {
        name
        optionType
        placeHolder
        regexPattern
        iconUrl
      }
      osIntStatuses {
        ...Status
      }
    }
    ... on DataControllerRequestsSpecialConfig {
      dataControllerStatuses {
        ...Status
      }
      filtersConfig {
        ...Filter
      }
    }
    ... on PendingActionsSpecialConfig {
      sendServiceRequestsTo
    }
    ... on DashboardSpecialConfig {
      complaintsFilterConfig {
        ...Filter
      }
      complaintsTableConfig {
        fieldId
      }
    }
    ... on ApprovalRequestsSpecialConfig {
      filtersConfig {
        ...Filter
      }
    }
    ... on CrimeLinksSpecialConfig {
      dropdownOptions {
        ...SearchDropdownOption
      }
    }
  }
  ${StatusFragmentDoc}
  ${FilterFragmentDoc}
  ${SearchDropdownOptionFragmentDoc}
`
export const BoardConfigFragmentDoc = gql`
  fragment BoardConfig on BoardConfig {
    externalLink
    specialConfig {
      ...BoardSpecialConfig
    }
  }
  ${BoardSpecialConfigFragmentDoc}
`
export const BoardFragmentDoc = gql`
  fragment Board on Board {
    boardId
    name
    boardType
    displayState
    defaultIcon
    selectedIcon
    config {
      ...BoardConfig
    }
  }
  ${BoardConfigFragmentDoc}
`
export const GetBoardsDocument = gql`
  query GetBoards {
    getBoards {
      ... on GetBoardsResult {
        boards {
          ...Board
        }
      }
    }
  }
  ${BoardFragmentDoc}
`
export type GetBoardsQueryResult = Apollo.QueryResult<
  GetBoardsQuery,
  GetBoardsQueryVariables
>
